export default "__VITE_ASSET__Dv20N5jj__"